export default __webpack_public_path__ + "static/media/vc.eac61837.jpg";